import { Component, inject, ViewChild } from '@angular/core';
import { ModalComponent } from '@catch/general-ui';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoPipe } from '@jsverse/transloco';
import { ColorService } from '../../../services/color.service';

@Component({
  selector: 'app-privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.scss'],
  imports: [ModalComponent, TranslocoPipe, TranslocoDirective],
})
export class PrivacyModalComponent {
  @ViewChild('modal', { static: false }) modal: ModalComponent;

  public colorService = inject(ColorService);
}
